export default "__VITE_ASSET__C4Ao4aVI__"